import { Event } from "../../contracts";

export const scoreHelper = (event: Event) => {
    let homeScore = event.score.homeScore;
    let awayScore = event.score.awayScore;

    if (event.isTeamSwap) {
        homeScore = event.score.awayScore;
        awayScore = event.score.homeScore;
    }
    return { homeScore, awayScore };
}